import { useInputMask } from "./useInputMask";

export const useTimeInputMask = () => {
  return useInputMask("99:99Hm", {
    customPatternCharacterRegexps: {
      H: /[aApP]/
    },
    renderValue: (value) => {
      const hours = value.slice(0, 2);
      const minutes = value.slice(3, 5);
      const separator = value.slice(2, 3);
      const ampm = String(value.slice(5)).toLowerCase();

      return `${hours && Number(hours) > 12 ? 12 : hours}${separator}${
        minutes && Number(minutes) > 59 ? 59 : minutes
      }${
        ampm && ampm.length === 2 && ampm !== "am" && ampm !== "pm"
          ? "am"
          : ampm
      }`;
    }
  });
};
